import {
  Combobox as MantineCombobox,
  ComboboxProps,
  useCombobox,
} from '@mantine/core';

export type IComboboxProps = ComboboxProps;

/** @registry Design-layer pass-through over Mantine Combobox and useCombobox; import these instead of @mantine/core outside src/design. Extend here when Combobox needs house behavior. Compound statics (Combobox.Target, Combobox.Dropdown, Combobox.Option, ...) are preserved. */
export const Combobox = MantineCombobox;
export { useCombobox };
